import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';

LoadingIndicator.propTypes = {
  size: PropTypes.number,
  withHeader: PropTypes.bool,
};

export default function LoadingIndicator({ size = 40, withHeader = true }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: withHeader ? 'calc(100vh - 64px)' : '100vh',
        width: '100%',
        position: 'fixed',
        top: withHeader ? 64 : 0,
        left: 0,
        backgroundColor: 'background.default',
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
}
